import React from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useHistory } from "react-router-dom";
import { roles, useAuth } from "../../services/auth";
import useNotificationStore from "../../Store/Notifications/NotificationStore";
import styles from "./NotificationPanel.module.scss";
import useCompanyStore from "../../Store/supplierCompany/companyData";

const NotificationPanel: React.FC = () => {
  const history = useHistory();
  const { companyName } = useCompanyStore();
  const { currentRoleId } = useAuth();
  const notifications = useNotificationStore((state) => state.notifications);
  const markAsRead = useNotificationStore((state) => state.markAsRead);
  const markAllAsRead = useNotificationStore((state) => state.markAllAsRead);
  const close = useNotificationStore((state) => state.close);

  const handleNotificationClick = (notification: NotificationItem) => {
    markAsRead(notification.salesConsultancyHashid);

    if (notification.roomUuid) {
      let path;

      if (currentRoleId === roles.client) {
        path = `/${companyName}/cliente/asesoria/${notification.salesConsultancyHashid}/chat`;
      } else if (currentRoleId === roles.salesperson) {
        path = `/vendedor/asesoria/${notification.salesConsultancyHashid}/chat`;
      }

      if (path) {
        history.push(path);
        close();
      }
    }
  };

  const formatNotificationTime = (date: Date) => {
    return format(new Date(date), "HH:mm - dd MMM", { locale: es });
  };

  return (
    <div className={styles.notificationPanel}>
      <div className={styles.notificationHeader}>
        <h3>Notificaciones</h3>
        <button className={styles.readAllButton} onClick={markAllAsRead}>
          Marcar todas como leídas
        </button>
      </div>

      <div className={styles.notificationList}>
        {notifications.length === 0 ? (
          <div className={styles.emptyState}>
            No tienes notificaciones nuevas
          </div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className={`${styles.notificationItem} ${
                !notification.read ? styles.unread : ""
              }`}
              onClick={() => handleNotificationClick(notification)}
            >
              <div className={styles.notificationContent}>
                <div className={styles.notificationSender}>
                  <span className={styles.senderName}>
                    {notification.sender.name}
                  </span>
                  <span className={styles.notificationTime}>
                    {formatNotificationTime(notification.timestamp)}
                  </span>
                </div>
                <p className={styles.notificationMessage}>
                  {notification.message}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;
